import Auth from './auth';
import axios from 'axios';
import { API_ROOT } from './apiConfig';

// "This file was already uploaded" (SoftwareFactory spec/upload-reupload-warning.md).
// Only a SHA-256 of the file leaves the browser for this check: never its content or name.
const auth = new Auth();

const readArrayBuffer = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('FileReader error'));
    reader.readAsArrayBuffer(file);
});

const webCrypto = () => (typeof window !== 'undefined' && window.crypto && window.crypto.subtle) || null;

// Hex SHA-256 of the file bytes, or null when this browser cannot hash it (the check is then skipped).
export const sha256Hex = async (file) => {
    const subtle = webCrypto();
    if (!subtle || !file) return null;
    try {
        const digest = await subtle.digest('SHA-256', await readArrayBuffer(file));
        return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, '0')).join('');
    } catch (_) {
        return null;
    }
};

// Earlier uploads of the same file by this account (last 30 days), or [] when there are none or
// the check could not run (WebApi or database not ready yet): the check never blocks an upload.
export const findPriorUploads = async (account, sha256) => {
    const config = {
        timeout: 15000,
        headers: {
            "Authorization": `Bearer ${auth.getToken()}`
        }
    };
    const response = await axios.post(`${API_ROOT}/api/v1/Aideo/Coding/Ocr/PriorUploads`, { AccountNumber: account, Sha256: sha256 }, config);
    const data = response && response.data;
    return data && data.Checked === true && Array.isArray(data.Uploads) ? data.Uploads : [];
};

// [{ file, uploads }] for each selected file that was already uploaded. One file at a time so a
// large batch is never held in memory at once; any failure means "no warning" for that file.
export const findAlreadyUploadedFiles = async (account, files) => {
    const hits = [];
    for (const file of files || []) {
        try {
            const sha256 = await sha256Hex(file);
            if (!sha256) continue;
            const uploads = await findPriorUploads(account, sha256);
            if (uploads.length > 0) hits.push({ file, uploads });
        } catch (_) {
            // Fail open: an unavailable check must not stop an upload.
        }
    }
    return hits;
};



// WEBPACK FOOTER //
// ./src/services/priorUploadService.js